import { render, staticRenderFns } from "./CaseArchiveViewer.vue?vue&type=template&id=27a18a70&scoped=true&"
import script from "./CaseArchiveViewer.vue?vue&type=script&lang=js&"
export * from "./CaseArchiveViewer.vue?vue&type=script&lang=js&"
import style0 from "./CaseArchiveViewer.vue?vue&type=style&index=0&id=27a18a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a18a70",
  null
  
)

export default component.exports